import { useEffect, useState } from "react";
import { db } from "./firebase";
import { collection, getDocs } from "firebase/firestore";
import "./App.css";

function OnePieceResults() {
  const [decks, setDecks] = useState([]);
  const [selectedDeck, setSelectedDeck] = useState(null);
  const [sortConfig, setSortConfig] = useState(null);

  const leaderIcons = {
    "Purple Black Luffy": "https://cdn.gumgum.gg/images/leaders/squares/OP09-061.webp",
    "Green Yellow Yamato": "https://cdn.gumgum.gg/images/leaders/squares/OP06-022.webp",
    "Green Yellow Law": "https://cdn.gumgum.gg/images/leaders/squares/OP10-022.webp",
    "Red Zoro": "https://cdn.gumgum.gg/images/leaders/squares/OP01-001.webp",
    "Blue Black Usopp": "https://cdn.gumgum.gg/images/leaders/squares/OP10-042.webp",
    "Yellow Kid": "https://cdn.gumgum.gg/images/leaders/squares/OP10-099.webp",
    "Yellow Vegapunk": "https://cdn.gumgum.gg/images/leaders/squares/OP07-097.webp",
    "Blue Purple Reiju": "https://cdn.gumgum.gg/images/leaders/squares/OP06-042.webp",
    "Red Yellow Belo Betty": "https://cdn.gumgum.gg/images/leaders/squares/OP05-002.webp",
    "Purple Yellow Pudding": "https://cdn.gumgum.gg/images/leaders/squares/OP08-058.webp",
    "Green Bonney": "https://cdn.gumgum.gg/images/leaders/squares/OP07-019.webp",
    "Red Green Smoker": "https://cdn.gumgum.gg/images/leaders/squares/OP10-001.webp",
    "Red Green Oden": "https://cdn.gumgum.gg/images/leaders/squares/EB01-001.webp",
    "Yellow Purple Robin": "https://cdn.gumgum.gg/images/leaders/squares/OP09-062.webp",
    "Blue Buggy": "https://cdn.gumgum.gg/images/leaders/squares/OP09-042.webp",
    "Blue Yellow Nami": "https://cdn.gumgum.gg/images/leaders/squares/OP11-041.webp",
    "Black Yellow Luffy": "https://cdn.gumgum.gg/images/leaders/squares/ST13-003.webp",
    "Red Blue Vivi": "https://cdn.gumgum.gg/images/leaders/squares/OP04-001.webp",
    "Red Purple Kid": "https://cdn.gumgum.gg/images/leaders/squares/ST10-003.webp",
    "Red Black Garp": "https://cdn.gumgum.gg/images/leaders/squares/OP02-002.webp",
    "Red Blue Marco": "https://cdn.gumgum.gg/images/leaders/squares/OP08-002.webp",
    "Red Shanks": "https://cdn.gumgum.gg/images/leaders/squares/OP09-001.webp",
    "Green Purple Lim": "https://cdn.gumgum.gg/images/leaders/squares/OP09-022.webp",
    "Blue Doflamingo": "https://cdn.gumgum.gg/images/leaders/squares/OP01-060.webp",
    "Green Purple Luffy": "https://cdn.gumgum.gg/images/leaders/squares/EB02-010.webp",
    "Green Blue Rosinante": "https://cdn.gumgum.gg/images/leaders/squares/OP05-022.webp",
    "Purple Luffy": "https://cdn.gumgum.gg/images/leaders/squares/OP05-060.webp",
    "Blue Yellow Ace": "https://cdn.gumgum.gg/images/leaders/squares/ST13-002.webp",
    "Green Zoro": "https://cdn.gumgum.gg/images/leaders/squares/OP12-020.webp",
    "Red Yellow Sabo": "https://cdn.gumgum.gg/images/leaders/squares/ST13-001.webp",
    "Black Yellow Koala": "https://cdn.gumgum.gg/images/leaders/squares/OP12-081.webp",
    "Red Rayleigh": "https://cdn.gumgum.gg/images/leaders/squares/OP12-001.webp",
    "Red Blue Ace": "https://cdn.gumgum.gg/images/leaders/squares/OP13-002.webp",
    "Black Imu": "https://cdn.gumgum.gg/images/leaders/squares/OP13-079.webp",
    "Blue Ace & Newgate": "https://cdn.gumgum.gg/images/leaders/squares/ST22-001.webp",
    "Black Teach": "https://cdn.gumgum.gg/images/leaders/squares/OP09-081.webp",
    "Black Crocodile": "https://cdn.gumgum.gg/images/leaders/squares/OP14-079.webp",
    "Red Black Sabo": "https://cdn.gumgum.gg/images/leaders/squares/OP13-004.webp",
    "Red Purple Roger": "https://cdn.gumgum.gg/images/leaders/squares/OP13-003.webp",
    "Blue Yellow Hancock": "https://cdn.gumgum.gg/images/leaders/squares/OP14-041.webp",
    "Blue Purple Sanji": "https://cdn.gumgum.gg/images/leaders/squares/OP12-041.webp",
    "Purple Foxy": "https://cdn.gumgum.gg/images/leaders/squares/OP07-059.webp",
    "Red Blue Lucy": "https://cdn.gumgum.gg/images/leaders/squares/OP15-002.webp",
    "Purple Enel": "https://cdn.gumgum.gg/images/leaders/squares/OP15-058.webp",
    "Red Blue Vivi (EB03)": "https://cdn.gumgum.gg/images/leaders/squares/EB03-001.webp",
    "Yellow Luffy (OP15)": "https://cdn.gumgum.gg/images/leaders/squares/OP15-098.webp",
   "Green Blue Luffy": "https://cdn.gumgum.gg/images/leaders/squares/OP16-022.webp", 
   "Black Yamato": "https://cdn.gumgum.gg/images/leaders/squares/OP16-079.webp",
   "Purple Yellow Rosinante": "https://cdn.gumgum.gg/images/leaders/squares/OP12-061.webp",
    // Add more leader-icon mappings here
  };

 useEffect(() => {
  const fetchData = async () => {
    const querySnapshot = await getDocs(collection(db, "decks"));
    const allDecks = [];

    const parseDate = (str) => {
      const [day, month, year] = str.split(".");
      return new Date(Date.UTC(year, month - 1, day));
    };

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      allDecks.push({
        player: data.Oyuncu,
        leader: data.Deste,
        decklistUrl: data.decklistUrl,
        placement: data.Sıralama,
        tournamentDate: data.Tarih,
        tournamentDateParsed: parseDate(data.Tarih), // store parsed date separately
        participants: data.Katılımcı,
        format: data.format,
        organizer: data.organizer,
      });
    });

    // Sort by parsed date descending, then placement ascending
    allDecks.sort((a, b) => {
      if (a.tournamentDateParsed > b.tournamentDateParsed) return -1;
      if (a.tournamentDateParsed < b.tournamentDateParsed) return 1;
      return a.placement - b.placement;
    });

    setDecks(allDecks);
  };

  fetchData();
}, []);


  const sortBy = (key) => {
  let direction = "ascending";
  if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
    direction = "descending";
  }

  const sortedData = [...decks].sort((a, b) => {
    let aValue = a[key];
    let bValue = b[key];

    const isDate = /^\d{2}\.\d{2}\.\d{4}$/.test(aValue);

    if (isDate) {
    const parseDate = (str) => {
      const [day, month, year] = str.split(".");
      return new Date(Date.UTC(year, month - 1, day)); // Safe, works cross-browser
    };

      aValue = parseDate(aValue);
      bValue = parseDate(bValue);
    }

    if (aValue < bValue) return direction === "ascending" ? -1 : 1;
    if (aValue > bValue) return direction === "ascending" ? 1 : -1;
    return 0;
  });

  setDecks(sortedData); // Directly update the decks with sorted version
  setSortConfig({ key, direction });
};


  return (
    <div className="app-container">
      <h1 className="app-title">Türkiye One Piece TCG Turnuva Sonuçları</h1>

      <table className="deck-table">
        <thead>
          <tr>
            <th onClick={() => sortBy("tournamentDate")}>Tarih</th>
            <th onClick={() => sortBy("leader")}>Lider</th>
            <th onClick={() => sortBy("player")}>Oyuncu</th>
            <th onClick={() => sortBy("placement")}>Sıralama</th>
            <th onClick={() => sortBy("participants")}>Katılımcı Sayısı</th>
            <th onClick={() => sortBy("format")}>Format</th>
            <th onClick={() => sortBy("organizer")}>Organizatör</th>
          </tr>
        </thead>
        <tbody>
          {decks.map((deck, index) => (
            <tr
              key={index}
              className="deck-row"
              onClick={() => setSelectedDeck(deck)}
            >
              <td>{deck.tournamentDate}</td>
              <td>
                <div className="leader-cell">
                  {leaderIcons[deck.leader] && (
                    <img
                      src={leaderIcons[deck.leader]}
                      alt={deck.leader}
                      className="leader-icon"
                    />
                  )}
                  <span>{deck.leader}</span>
                </div>
              </td>
              <td>{deck.player}</td>
              <td>
                <span className={`badge ${deck.placement === 1 ? "gold" : deck.placement === 2 ? "silver" : deck.placement === 3 ? "bronze" : ""}`}>
                  {deck.placement}
                </span>
              </td>
              <td>{deck.participants}</td>
              <td>{deck.format}</td>
              <td>{deck.organizer}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {selectedDeck && (
        <div className="modal-overlay">
          <div className="modal">
            <button
              className="close-button"
              onClick={() => setSelectedDeck(null)}
            >
              ✕
            </button>
            <h2 className="modal-title">
              {selectedDeck.player} – {selectedDeck.leader}
            </h2>
            <img
              src={selectedDeck.decklistUrl}
              alt="Decklist"
              className="modal-image"
            />
          </div>
        </div>
      )}

      <a href="https://www.instagram.com/pokot.tr/" target="_blank" rel="noopener noreferrer">
        <img src="https://i.ibb.co/HLfdrpYz/logo.png" alt="Pokot Logo" className="bottom-logo" />
      </a>
    </div>
  );
}

export default OnePieceResults;

